<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Languages",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Languages",
            items: [
               {
                  text: "Languages",
                  active: true,
               },                   
            ],

            listing_length: 10,
            keyword: '',
            status: '',

            languages: [],
            language: {
               id: "",
               language : "",
            },
            from: null,
            to: null,
            total: null,
            pagination: {},
            edit: false,
            language_status: {
               id: "",
               status: "",
            },
            modal_title: "Add Language",
            button_title: "Save",

            token: "",
            errors: {},
            activate: false,
            deactivate: false,
            
            loading: false,

            active_page_url: null,
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchLanguages();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },

         fetchLanguages(page_url = null) {

            this.getToken();
            let url = "api/admin/languages?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.languages = responseData.languages.data;
                  
                  this.pagination = responseData.languages.links;
                  this.from = responseData.languages.from;
                  this.to = responseData.languages.to;
                  this.total = responseData.languages.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 
         
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         editLanguage(language) {            
            this.modal_title = "Edit Language";
            this.button_title = "Update";
            this.language.id = language.id;
            this.language.language = language.language; 
              
            this.edit = true;
            this.showModal("language-modal");
         },

         addLanguage() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url;
            let formData = new FormData();

            if(!this.edit) {
               url = "api/admin/languages/add";

            } else {
               url = "api/admin/languages/update";
               formData.append("language_id", this.language.id); 
            }         

            formData.append("language", this.language.language); 
            
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('language-modal');
                  this.fetchLanguages(this.active_page_url);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         clearForm() {           
            
            this.modal_title = "Add Language";
            this.button_title = "Add";
            this.language.id = "";  
            this.language.language = "";           
            this.edit = false;
            this.errors = {};
         },

         activateLanguage(language) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this language?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.language_status.id = language.id;
                  this.language_status.status = 1;
                  this.updateLanguageStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateLanguage(language) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this language?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.language_status.id = language.id;
                  this.language_status.status = 2;
                  this.updateLanguageStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateLanguageStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            let url = "api/admin/languages/status?language_id=" + this.language_status.id + "&status=" + this.language_status.status;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchLanguages(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.language-modal variant="primary" class="float-end">Add Language</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchLanguages()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchLanguages()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchLanguages()">
                                 <option value="">All</option>
                                 <option value="1">Published</option>
                                 <option value="2">Unpublished</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                               
                           <tr>
                              <th width="10%">SI No</th>
                              <th width="15%">Language</th>
                              <th width="15%">Created On</th>
                              <th width="20%">Options</th>                              
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(languages.length)">
                           <tr v-for="(language, index) in languages" :key="language.id">
                              <td>{{from + index}}</td>
                              <td>{{language.language}}</td>  
                              <td>{{language.created_at | formatDateTime}}</td>
                              <td>
                                 <b-button variant="primary" class="btn-sm mt-2 me-1" @click="editLanguage(language)">Edit</b-button>                                
                                 <b-button v-if="language.status==1" variant="danger" class="btn btn-sm mt-2 me-2" @click="deactivateLanguage(language)">Unpublish</b-button>

                                 <b-button v-else variant="success" class="btn btn-sm mt-2 me-2" @click="activateLanguage(language)">Publish</b-button>
                              </td>
                           </tr>
                        </tbody>

                        <tbody v-else>
                           <tr>
                              <td colspan="6" class="text-center">No languages found</td>
                           </tr>
                        </tbody>

                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(languages.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchLanguages(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <b-modal ref="language-modal" id="language-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addLanguage()">                        
                        <div class="row"> 
                           <b-form-group class="col-lg-12">
                              <label>Language <span class="text-danger">*</span></label>
                              <b-form-input v-model="language.language" :class="{ 'is-invalid': Boolean(errors.language) }"></b-form-input>

                              <div v-for="(val, index) in errors.language" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary" :disabled="loading">
                                 <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                 {{ loading ? 'Saving...' : button_title }}
                              </b-button>
                              <b-button class="" variant="light" @click="hideModal('language-modal')" :disabled="loading">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
